import { MDBIcon } from "mdb-react-ui-kit";
import { useContext, useState } from "react";
import { TranslationContext } from "../../context/translations/translations-context";
import ExperienceList from "./experiences/ExperienceList";

export default function ExperiencesSection() {
    const [ isVisible, setIsVisible ] = useState( false );

    const { translations } = useContext( TranslationContext );
    return (
        <div className="text-white">
            <div className="subtitre-cv-container text-underline d-flex align-items-center gap-2"
                 onClick={ () => setIsVisible( !isVisible ) }
                 style={ { cursor: "pointer" } }
            >
                <h4 className="text-underline pt-1 text-white">{ translations.experiencesSection.title }</h4>
                <div className="line bg-white"></div>
                <MDBIcon
                    fas
                    icon={ "briefcase" }
                    style={ { color: "white" } }
                    size="lg"
                />
            </div>
            { isVisible && (
                <ExperienceList/>
            ) }
        </div>
    );
}
